import React, { CSSProperties, useEffect } from 'react';

import { t } from 'i18next';

import useDeviceDetect from 'hooks/useDeviceDetect';
import Card from 'components/Card/Card';
import bellIcon from 'assets/icons/header/upcoming.svg';
import { useUpcoming } from 'application/dashboard/upcomings/upcoming.context';
import RenderWithRole from 'hoc/renderWithRole';
import LoadButton from 'components/Button/LoadButton/LoadButton';
import { usePersistanOptions } from 'application/dashboard/persistantOptions/options.context';

import AddTask from './components/AddTask/AddTask';
import Tasks from './components/Tasks/Tasks';

import './Upcoming.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
}

const Upcoming: React.FC<Props> = ({ style }) => {
  const { isMobile } = useDeviceDetect();
  const { hasNext, hasPrev, queryLess, queryMore, data, getAssignments } = useUpcoming();
  const { upcomingShowAll, setOptionsProp } = usePersistanOptions();

  function toggleHiden() {
    setOptionsProp(!upcomingShowAll, 'upcomingShowAll');
  }

  useEffect(() => {
    upcomingShowAll
      ? getAssignments('change', {})
      : getAssignments('change', { _eq: upcomingShowAll });
  }, [upcomingShowAll]);

  useEffect(() => {
    getAssignments('change', {});
  }, [window.location.search]);

  function paginate(val) {
    if (val === 'next') {
      upcomingShowAll ? queryMore({}) : queryMore({ _eq: upcomingShowAll });
      return;
    }
    upcomingShowAll ? queryLess({}) : queryLess({ _eq: upcomingShowAll });
  }

  const AddTaskHeader = RenderWithRole({ teacher: <AddTask showAll={upcomingShowAll} /> });

  return (
    <div className="upcoming-container" style={style}>
      <Card
        title={
          <>
            <img className="card-icon" src={bellIcon} alt="bell icon" />
            {t('common:upcoming')}
          </>
        }
        foldable={isMobile}
      >
        {!isMobile && (
          <Card.Header>
            <img className="card-icon" src={bellIcon} alt="bell icon" />
            <h4 className="card-title">{t('common:upcoming')}</h4>
            {AddTaskHeader}
            <div className="filler" />
            <div>
              {upcomingShowAll ? (
                <span className="underline pointer" onClick={() => toggleHiden()}>
                  {t('common:show_uncompleted')}
                </span>
              ) : (
                <span className="underline pointer" onClick={() => toggleHiden()}>
                  {t('common:show_all')}
                </span>
              )}
            </div>
          </Card.Header>
        )}

        <Card.Body style={{ padding: '10px 24px' }}>
          <Tasks
            status="overdue"
            overdue={true}
            items={data.overdue}
            key={'overdue'}
            showAll={upcomingShowAll}
          />
          <Tasks status="today" items={data.today} key={'today'} showAll={upcomingShowAll} />
          <Tasks
            status="tomorrow"
            items={data.tomorrow}
            key={'tomorrow'}
            showAll={upcomingShowAll}
          />
          <LoadButton hasNext={hasNext} hasPrev={hasPrev} onClick={val => paginate(val)} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default Upcoming;
